"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FileInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button"));

var _Field = require("../Field");

var BUTTON_STYLE = {
  verticalAlign: 'middle' // match zsg-file-input-filename

};
var FILENAME_STYLE = {
  paddingLeft: 10 // ensure space between button and text

};

var FileInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FileInput, _Component);

  function FileInput(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FileInput);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FileInput).call(this, props));
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.state = {
      fileName: props.defaultFileName
    };
    return _this;
  }

  (0, _createClass2["default"])(FileInput, [{
    key: "onChange",
    value: function onChange(e) {
      var _this2 = this;

      var file = e.target.files[0];
      var fileName = file ? file.name : this.props.defaultFileName;
      this.setState({
        fileName: fileName
      }, function () {
        return _this2.props.onChange(file);
      });
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint "no-unused-vars": ["error", { "ignoreRestSiblings": true }] */
      var _this$props = this.props,
          buttonProps = _this$props.buttonProps,
          buttonText = _this$props.buttonText,
          className = _this$props.className,
          defaultFileName = _this$props.defaultFileName,
          onChange = _this$props.onChange,
          value = _this$props.value,
          inputProps = (0, _objectWithoutProperties2["default"])(_this$props, ["buttonProps", "buttonText", "className", "defaultFileName", "onChange", "value"]);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])('zsg-file-input', className)
      }, _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, buttonProps, {
        anchor: true,
        className: (0, _classnames["default"])({
          'zsg-file-input-button': true,
          'zsg-file-input-button_disabled': inputProps.disabled
        }),
        disabled: inputProps.disabled,
        style: BUTTON_STYLE
      }), buttonText, _react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
        type: "file",
        onChange: this.onChange
      }))), _react["default"].createElement("span", {
        className: "zsg-file-input-filename",
        style: FILENAME_STYLE
      }, this.state.fileName));
    }
  }]);
  return FileInput;
}(_react.Component);

exports.FileInput = FileInput;
FileInput.displayName = 'FileInputField';
FileInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   *  Props to pass to an internal [`<Button>`](#button) instance
   **/
  buttonProps: _propTypes["default"].objectOf(_propTypes["default"].any),

  /**
   *  Text rendered inside file selector button
   **/
  buttonText: _propTypes["default"].string,

  /**
   *  Additional classname(s) for root element
   **/
  className: _propTypes["default"].string,

  /**
   *  Text rendered inside file selector field when no file is selected.
   **/
  defaultFileName: _propTypes["default"].string,

  /**
   *  A callback that accepts the `File` object when selected.
   **/
  onChange: _propTypes["default"].func.isRequired,

  /**
   * "value" is not appropriate for a file input
   * @ignore
   **/
  value: _propTypes["default"].any
} : {};
FileInput.defaultProps = {
  buttonProps: {},
  buttonText: 'Choose file',
  defaultFileName: 'No file selected'
};
var FileInputField = (0, _Field.wrap)(FileInput);
var _default = FileInputField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/FileInputField/index.js
// module id = 527
// module chunks = 0